import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Partner } from '../api/model/partner';
import { EcondosQuery } from '@api/model/query';
import { environment } from '@environment';

import * as qs from 'qs';

@Injectable({ providedIn: 'root' })
export class PartnerService {
  //endpoint do backend usado para as funções
  private endPoint = `${environment.backendUrl}partners/`;

  constructor(private http: HttpClient) {}

  //retorna uma lista dos parceiros
  getPartners(params?: EcondosQuery): Observable<{ count: number; partners: Partner[] }> {
    const httpParams = new HttpParams({ fromString: qs.stringify(params) });
    return this.http
      .get(`${this.endPoint}`, {
        params: httpParams,
        observe: 'response' as 'body'
      })
      .pipe(
        map((res: any) => ({
          count: res.headers.get('count'),
          partners: res.body
        }))
      );
  }

  //retorna um parceiro específico com o id fornecido
  getPartnerById(partnerId: string, params?: EcondosQuery): Observable<Partner> {
    const httpParams = new HttpParams({ fromString: qs.stringify(params) });
    return this.http
      .get(this.endPoint + partnerId, {
        params: httpParams,
        observe: 'response' as 'body'
      })
      .pipe(map((res: any) => res.body));
  }

  //cria um novo parceiro com a informação enviada e retorna a informação dele
  createPartner(partner: Partner) {
    return this.http.post(this.endPoint, partner);
  }

  //atualiza a informação do parceiro de Id fornecido com a informação fornecida, e retorna o usuário atualizado
  updatePartner(partnerId: string, partner: Partner) {
    return this.http.put(this.endPoint + partnerId, partner);
  }

  //exclui o usuário com id fornecido retornando nada.
  deletePartner(partnerId: string) {
    return this.http.delete(this.endPoint + partnerId);
  }
}
